import React, {useState, useEffect} from 'react';
import LocationListItemListingImage from './LocationListItemListingImage';
import LocationListItemGalleryImage from './LocationListItemGalleryImage';
import type {ListingImgStyleProps} from '../../../../hooks/components/location/ListingImgStyles';

interface LocationListItemImagesProps extends ListingImgStyleProps {
  /** 0 shows the listing image; n shows gallery[n - 1]. */
  activeSlide: number;
  gallery: string[];
  listingImageFileName: string;
  locationId: string;
}

const LocationListItemImages = (props: LocationListItemImagesProps) => {
  const { activeSlide, gallery, listingImageFileName, locationId, ...other } = props;
  const [galleryImageFileName, setGalleryImageFileName] = useState<string>();
  const [showListingImage, setShowListingImage] = useState(true);

  useEffect(() => {
    if (activeSlide > 0) {
      setShowListingImage(false);
      setGalleryImageFileName(gallery[activeSlide-1]);
    } else {
      setShowListingImage(true)
    }
  }, [activeSlide, gallery])

  return (
    <div>
      {/* Falls back to the listing image if activeSlide is past the end of the gallery, which leaves galleryImageFileName undefined. */}
      { showListingImage || galleryImageFileName === undefined ? <LocationListItemListingImage listingImageFileName={listingImageFileName} {...other} /> : <LocationListItemGalleryImage galleryImageFileName={galleryImageFileName} locationId={locationId} {...other} />}
    </div>
  )
}

export default LocationListItemImages;
